module.exports = {
          srcSet: __webpack_public_path__ + "51843ddf847bd77bf5932576ed3f467a-500.png"+" 500w",
          images:[ {path: __webpack_public_path__ + "51843ddf847bd77bf5932576ed3f467a-500.png",width: 500,height: 306}],
          src: __webpack_public_path__ + "51843ddf847bd77bf5932576ed3f467a-500.png",
          toString:function(){return __webpack_public_path__ + "51843ddf847bd77bf5932576ed3f467a-500.png"},
          
          width: 500,
          height: 306
        }